import { parseDay } from './dates';

// "Jul 24, 2026" with the year in a span that phone rows hide (.bx-yr), so stacked rows read "Jul 24".
export function DateYr({ d }) {
  if (!d) return '—';
  const dt = parseDay(d);
  if (!dt) return '—';
  const full = dt.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
  const md = dt.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  if (!full.startsWith(md)) return full;
  return <>{md}<span className="bx-yr">{full.slice(md.length)}</span></>;
}
